type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  readContracts: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}
export type ClientData = {
  cpf: string
  created_at: string
  deleted_at?: string
  email: string
  id: number
  name: string
  status: string
  type: string
  values?: string
  updated_at: string
}

export type ContractApiResponse = {
  id: number
  cpf: string
  name: string
  payment_formtype: string
  status: string
  values: number
  created_at: string
  updated_at: string
  deleted_at?: string
}

const nameEntity = 'FormType'
const nameSource = 'commercial/contracts/formTypes'
const namePageTitle = 'Tipos de formulários'
const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Tipos de formulários',
  to: '/commercial/contracts/formTypes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/contracts/formTypes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/contracts/formTypes/',
    icon: 'fa fa-list'
  },
  readContracts: {
    name: 'Contratos',
    to: '/commercial/contracts/formTypes/contracts',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/contracts/formTypes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
